import { updateIntl } from 'react-intl-redux';

import { languages, messages } from '@app/constants/localization';

export function toggleLocale() {
  return (dispatch, getState) => {
    const { intl: { locale } } = getState();

    const newLocale = locale === languages.AR ? languages.EN : languages.AR;

    localStorage.setItem('language', newLocale);

    dispatch(updateIntl({
      locale: newLocale,
      messages: messages[newLocale],
    }));
  };
}
